import { API_URL } from 'constants/Api'

export const ASSETS = {
    images: `${API_URL}/`,
    FILES:  `${API_URL}/files/`,
}